// import { motion } from "framer-motion";

export default function LoadingScreen() {
    return (
        <section className="flex items-center justify-center h-screen bg-white dark:bg-gray-900 px-4">
            <div className="flex flex-col items-center space-y-4">

                <span className="loader"></span>
                <p className="text-gray-700 dark:text-gray-300 text-lg font-medium tracking-wide">
                    Loading... Please wait or login to continue.
                </p>
            </div>
        </section>
    );
}
